import { gql } from "@apollo/client";

export const GET_ALL_PRODUCTS = gql`
  query GetAllProducts {
    getAllProducts {
      message
      data {
        id
        price
        name
        description
        organizationId
        type
        images
      }
      meta {
        total
        currentPage
        lastPage
        size
      }
    }
  }
`;

export const GET_ALL_PRODUCTS_BY_ORGANIZATION_ID = gql`
  query GetAllProductsByOrganizationId(
    $payload: getAllProductsByOrganizationIdPayload!
  ) {
    getAllProductsByOrganizationId(payload: $payload) {
      message
      data {
        id
        price
        name
        description
        organizationId
        type
        images
      }
      meta {
        total
        currentPage
        lastPage
        size
      }
    }
  }
`;

export const GET_PRODUCT = gql`
  query GetProductById($getProductByIdId: String!) {
    getProductById(id: $getProductByIdId) {
      id
      name
      description
      images
      type
      minAmount
      maxAmount
      price
      organizationId
      currency
      paymentType
      billingPeriod
      status
      quantity
      createdAt
      updatedAt
    }
  }
`;

export const SEARCH_PRODUCT = gql`
  query SearchProduct($query: String!) {
    searchProduct(query: $query) {
      id
      name
      description
      images
      type
      minAmount
      maxAmount
      price
      organizationId
      currency
      paymentType
      createdAt
      updatedAt
      billingPeriod
      customPeriod {
        number
        period
      }
      status
      quantity
    }
  }
`;

export const GET_PAYMENT_LINK = gql`
  query PaymentLink($paymentLinkId: ID!) {
    paymentLink(id: $paymentLinkId) {
      advanceOption {
        redirectAfterPayment
        useYourCustomLink
        successMessage
      }
      id
      options {
        collectCustomersShippingAddress
        allowBusinessCustomersToProvideTaxIds
        collectTaxAutomatically
        includeTaxInPrice
        limitTheNumberOfPayments
        taxCategory
      }
      organizationId
      shortcode
      type
      products {
        billingPeriod
        currency
        customPeriod {
          number
        }
        description
        id
        images
        maxAmount
        minAmount
        name
        organizationId
        paymentLinks {
          id
          advanceOption {
            redirectAfterPayment
            useYourCustomLink
            successMessage
          }
          organizationId
          shortcode
          type
          products {
            id
            name
            description
            images
            type
            minAmount
            maxAmount
            price
            organizationId
            currency
            paymentType
            createdAt
            updatedAt
            billingPeriod
            customPeriod {
              number
              period
            }
            status
          }
          options {
            collectCustomersShippingAddress
            limitTheNumberOfPayments
            allowBusinessCustomersToProvideTaxIds
            collectTaxAutomatically
            taxCategory
            includeTaxInPrice
          }
        }
      }
    }
  }
`;

export const GET_PAYMENT_LINK_BY_ORGANIZATION_ID = gql`
  query GetAllpaymentLinkByOrganizationId(
    $payload: getAllpaymentLinkByOrganizationIdPayload!
  ) {
    getAllpaymentLinkByOrganizationId(payload: $payload) {
      message
      meta {
        total
        currentPage
        lastPage
        size
      }
      data {
        advanceOption {
          successMessage
          useYourCustomLink
          redirectAfterPayment
        }
        id
        options {
          collectCustomersShippingAddress
          limitTheNumberOfPayments
          allowBusinessCustomersToProvideTaxIds
          collectTaxAutomatically
          taxCategory
          includeTaxInPrice
        }
        organizationId
        paymentLinkProducts {
          paymentLinkId
          productId
          id
          letCustomerAdjustQuantity
          minQuantity
          maxQuantity
        }
        shortcode
        createdAt
        updatedAt
        type
        products {
          id
          name
          description
          images
          type
          minAmount
          maxAmount
          createdAt
          updatedAt
          price
          organizationId
          currency
          paymentType
          billingPeriod
          customPeriod {
            number
            period
          }
          status
          quantity
        }
      }
    }
  }
`;

export const GET_BRAND_SETTINGS_BY_ORGANIZATION_ID = gql`
  query GetAdvanceBrandSettingsByOrganizationId(
    $input: GetBrandSettingsInput!
  ) {
    getAdvanceBrandSettingsByOrganizationId(input: $input) {
      id
      primaryColor
      secondaryColor
      primaryLogo
      whiteBackgroundLogo
      Heading1fontStyle
      Heading1fontSizes
      Heading2fontStyle
      Heading2fontSizes
      SubHeadingfontStyle
      SubHeadingfontSizes
      companyName
      companyDescription
      keywords
      socialMediaLinks
      backgroundImages
      headerImages
      customCss
      emailTemplates
      meta
      legalInformation
      organizationId
      status
      createdAt
      updatedAt
    }
  }
`;

export const GET_PAYMENT_LINK_BY_SHORTCODE = gql`
  query PaymentLinkByShortcode($id: String!) {
    paymentLinkByShortcode(id: $id) {
      products
      paymentLink {
        advanceOption {
          redirectAfterPayment
          useYourCustomLink
          successMessage
        }
        id
        options {
          collectCustomersShippingAddress
          allowBusinessCustomersToProvideTaxIds
          collectTaxAutomatically
          includeTaxInPrice
          limitTheNumberOfPayments
          taxCategory
        }
        organizationId
        shortcode
        type
        products {
          billingPeriod
          currency
          customPeriod {
            number
          }
          description
          id
          images
          maxAmount
          minAmount
          name
          organizationId
          paymentLinks {
            id
            advanceOption {
              redirectAfterPayment
              useYourCustomLink
              successMessage
            }
            organizationId
            shortcode
            type
            products {
              id
              name
              description
              images
              type
              minAmount
              maxAmount
              price
              organizationId
              currency
              paymentType
              billingPeriod
              customPeriod {
                number
                period
              }
              status
            }
            options {
              collectCustomersShippingAddress
              limitTheNumberOfPayments
              allowBusinessCustomersToProvideTaxIds
              collectTaxAutomatically
              taxCategory
              includeTaxInPrice
            }
          }
        }
      }
    }
  }
`;
export const GET_PAYMENT_TRANSACTION_BY_REFERENCE = gql`
  query PaymentTransactionByReference(
    $id: String!
    $type: String
    $paymentRef: String
  ) {
    paymentTransactionByReference(id: $id, type: $type, paymentRef: $paymentRef)
  }
`;
